import React from 'react';
import { Route } from '@americanexpress/one-app-router';

const childRoutes = () => [<Route key="/" path="/" />];

export default childRoutes;
